import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'ag-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SpinnerComponent {
  readonly size = input(2);
}
